import { render, staticRenderFns } from "./password-lost.vue?vue&type=template&id=3d04db6b&"
import script from "./password-lost.vue?vue&type=script&lang=ts&"
export * from "./password-lost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports